import React from "react";
import Select from "react-select";

const RSelect = ({ ...props }) => {
  return (
    <div className="form-control-select">
      <Select
        placeholder={props.placeholder}
        className={`react-select-container ${props.className ? props.className : ""}`}
        classNamePrefix="react-select"
        components={{ Option: props?.customOption }}
        {...props}
      />
    </div>
  );
};

export default RSelect;
